import React from 'react';
import { View } from 'react-native';
import { useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';

import { Title, Text } from 'app/src/styles';
import { Link } from 'app/src/utils/routing';

import { EVENT_TYPES } from './queries';

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  {
    key: 'parent',
    label: 'Parent',
    value: ({ value }) => value?.name,
    content: ({ entry, value }) => (
      value && (
        <Link to={`/event-types/${entry.parent.id}`}>
          <Text>{value}</Text>
        </Link>
      )
    ),
  },
  {
    key: 'emoji',
    label: 'Emoji',
  },
  {
    key: 'actions',
    sort: 'prevent',
    content: ({ entry }) => (
      <Link to={`/event-types/${entry.id}`}>
        <Text>View/Edit</Text>
      </Link>
    ),
  }
];

const EventTypes = () => {
  const { data } = useQuery(EVENT_TYPES, { fetchPolicy: 'network-only' } );

  return (
    <View>
      <Title>Event Types</Title>

      <Link to="/event-types/new">
        <Text>Add Event Type</Text>
      </Link>

      {data && (
        <DataTable.Simple
          data={data.eventTypes}
          columns={columns}
        />
      )}
    </View>
  );
};

export default EventTypes;
